import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {WebUtils} from '../utils/web.utils';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (route.queryParams && route.queryParams.accessToken) {
      // clear the old caching user data
      localStorage.removeItem('user');
      // auth and get new user data by token
      const accessToken = route.queryParams.accessToken;
      const activeAccount = Number(route.queryParams.activeAccount);
      return this.auth.loginByToken(accessToken, activeAccount);
    }

    if (route.queryParams && route.queryParams.inviteToken) {
      // clear the old caching user data
      localStorage.removeItem('user');
      const segmentPath = state.url.split('/new?inviteToken=')[0];
      if (segmentPath.indexOf('/dashboard/campaigns/') < 0) {
        return false;
      }
      // auth and get new user data by token
      const inviteToken = route.queryParams.inviteToken;
      const campaignId = segmentPath.replace('/dashboard/campaigns/', '');
      const activeAccount = Number(route.queryParams.activeAccount);
      return this.auth.loginByInviteToken(inviteToken, campaignId,  activeAccount);
    }

    if (localStorage.getItem('user')) {
      return true;
    } else {
      const targetUrl = WebUtils.getTargetUrl();
      const path = WebUtils.isRequestAuthorizedInfluencerAppPage() ? '/influencer/login' : '/login';
      this.router.navigate([path], {queryParams: {target_url: targetUrl}});
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth.guard.ts